import React from 'react';
import classnames from 'classnames';
import * as Dropdown from 'hellospa/foundation/control/dropdown';
import { PropsOf } from 'hellospa/ts-utils';
import styles from './styles.scss';

type InputProps = {
  inputProps: Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'value' | 'onChange' | 'placeholder'
  >,
};

type BtnProps = PropsOf<typeof Dropdown.Button> & {
  hideArrow?: boolean,
  value: React.InputHTMLAttributes<HTMLInputElement>['value']
  onChange: React.InputHTMLAttributes<HTMLInputElement>['onChange']
  placeholder?: React.InputHTMLAttributes<HTMLInputElement>['placeholder']
  id: string,
}

export function Button({
  hideArrow,

  // Dropdown.Button props
  children,
  className,

  // Input props
  value,
  onChange,
  placeholder,
  id,
  inputProps,
  ...props
}: BtnProps & InputProps) {
  const handleKeyDown = React.useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    switch (event.key) {
      // Let this bubble up to Dropdown.Button so it can open the menu
      case 'ArrowDown':
        break;
      // All other keys need to be stopped here. If a letter doesn't match a
      // menu item Dropdown.Button will cancel the event.
      default:
        event.stopPropagation();
    }
  }, []);

  return (
    <Dropdown.Button
      tabIndex={-1}
      className={classnames(styles.button, { [styles.hideArrow]: hideArrow }, className)}
      {...props}
    >
      <input
        type="text"
        id={id}
        className={styles.input}
        onClick={(e) => { e.stopPropagation(); }}
        placeholder={placeholder}
        autoComplete="off"
        onKeyDown={handleKeyDown}
        name={name}
        value={value}
        onChange={onChange}
        {...inputProps} />
      <span className={styles.spacer} />
      {children}
    </Dropdown.Button>
  );
}

type WrapperProps = PropsOf<typeof Dropdown.Wrapper>
export function Wrapper({ children, onSelection, ...props }: WrapperProps) {
  return (
    <Dropdown.Wrapper onSelection={onSelection} className={styles.dropdown} {...props}>
      {children}
    </Dropdown.Wrapper>
  );
}

export const Menu = Dropdown.Menu;
export const MenuItem = Dropdown.MenuItem;
export const openMenu = Dropdown.openMenu;
export const closeMenu = Dropdown.closeMenu;
